<template>
  <div class="hm-status" ref="root">
    <button
      @click="toggle"
      class="hm-status__btn"
      type="button"
      :style="{ color: status.color }"
      :disabled="!hasOptions"
    >
      <span class="hm-status__text">{{ status.name }}</span>
      <svg v-if="hasOptions" class="hm-status__caret" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2"/>
      </svg>
    </button>

    <transition name="hm-status-fade">
      <div v-if="open && hasOptions" class="hm-status__dropdown">
        <div
          v-for="opt in status.available_statuses"
          :key="opt.code"
          class="hm-status__option"
          :class="{ 'hm-status__option--selected': opt.code === status.code }"
          :style="{ color: opt.color || '#000' }"
          @click="onSelect(opt)"
        >
          {{ opt.name }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HMStatus',
  props: {
    status: { type: Object, required: true }
  },
  data() {
    return { open: false }
  },
  computed: {
    hasOptions() {
      return (
        this.status?.available_statuses?.length || 0
      ) > 0
    }
  },
  methods: {
    toggle() {
      if (!this.hasOptions) return
      this.open = !this.open
      if (this.open) document.addEventListener('click', this.onDocClick, true)
      else document.removeEventListener('click', this.onDocClick, true)
    },
    close() {
      this.open = false
      document.removeEventListener('click', this.onDocClick, true)
    },
    onDocClick(e) {
      const root = this.$refs.root
      if (root && !root.contains(e.target)) this.close()
    },
    onSelect(opt) {
      this.$emit('select', opt)
      this.close()
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick, true)
  }
}
</script>

<style scoped>
.hm-status {
  position: relative;
}

.hm-status__btn {
  height: 40px;
  border-radius: 30px;
  border: 1px solid #ECEAE5;
  background: #FCFCFC;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 14px 0 16px;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
}

.hm-status__btn:disabled {
  cursor: default;
}

.hm-status__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hm-status__caret {
  flex: 0 0 auto;
  opacity: .7;
}

.hm-status__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  min-width: 180px;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid #E9E9E9;
  background: #FFF;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
}

.hm-status__option {
  margin-bottom: 5px;
  padding: 6px 10px 4px;
  border-radius: 6px;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.hm-status__option:last-child {
  margin-bottom: 0;
}

.hm-status__option:hover,
.hm-status__option--selected {
  background: linear-gradient(180deg, #EEE 0%, #EDEDED 100%);
}

.hm-status__option--selected {
  pointer-events: none;
}

/* плавное появление списка */
.hm-status-fade-enter-active,
.hm-status-fade-leave-active {
  transition: opacity 0.12s ease;
}

.hm-status-fade-enter,
.hm-status-fade-leave-to {
  opacity: 0;
}
</style>
